import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Button } from '../components/ui/Button';
import { Upload, MapPin, Plus, X, Save, ExternalLink, Leaf, Eye, ChevronDown, ChevronUp, Search } from 'lucide-react';
const Profile = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showAddLocationModal, setShowAddLocationModal] = useState(false);
  const [isLocationsExpanded, setIsLocationsExpanded] = useState(false);
  const [locationSearchTerm, setLocationSearchTerm] = useState('');
  const [toast, setToast] = useState<{
    message: string;
    type: 'success' | 'error';
    show: boolean;
  }>({
    message: '',
    type: 'success',
    show: false
  });
  const [formData, setFormData] = useState({
    logo: 'https://blog.lasaponaria.it/hubfs/LaSaponaria-5.jpg',
    name: 'La Saponaria',
    website: 'https://www.lasaponaria.it/',
    description: 'Marchio italiano di cosmetici naturali, biologici e consapevoli. Società Benefit dal 2023, produciamo cosmetici artigianali con ingredienti biologici certificati, packaging ecologico e produzione 100% italiana con energia rinnovabile.',
    sector: 'Cosmetici Naturali e Biologici',
    founded: '2009',
    headquarters: 'Pesaro, Italia',
    certifications: ['Biologico Certificato', 'Società Benefit', 'Cruelty Free', 'Vegan OK']
  });
  const [locations, setLocations] = useState([{
    id: 1,
    name: 'Ancona',
    address: 'Corso Mazzini 67'
  }, {
    id: 2,
    name: 'Bastia Umbra',
    address: 'Via Roma 15'
  }, {
    id: 3,
    name: 'Battipaglia',
    address: 'Via Mazzini 91'
  }, {
    id: 4,
    name: 'Bologna',
    address: 'Strada Maggiore 35/C'
  }, {
    id: 5,
    name: 'Civitanova',
    address: 'Corso Umberto I, 79'
  }, {
    id: 6,
    name: 'Fano',
    address: 'Corso Matteotti 124'
  }, {
    id: 7,
    name: 'Milano Centro',
    address: 'Corso Garibaldi 64'
  }, {
    id: 8,
    name: 'Milano Solari',
    address: 'Via Solari 15'
  }, {
    id: 9,
    name: 'Modena',
    address: 'Via Emilia Centro 168'
  }, {
    id: 10,
    name: 'Montebelluna',
    address: 'Piazza Oberkochen 30'
  }, {
    id: 11,
    name: 'Parma',
    address: 'Str. Giuseppe Garibaldi, 1c'
  }, {
    id: 12,
    name: 'Pescara',
    address: 'Via Firenze, 112'
  }, {
    id: 13,
    name: 'Ravenna',
    address: 'Via Cavour 58'
  }, {
    id: 14,
    name: 'Rimini',
    address: 'Via Garibaldi 27'
  }, {
    id: 15,
    name: 'Roma Cola di Rienzo',
    address: 'Via Cola di Rienzo 265/A'
  }, {
    id: 16,
    name: 'Roma Bergamo',
    address: 'Via Bergamo, 4'
  }, {
    id: 17,
    name: 'Sassari',
    address: 'Via Brigata Sassari 46'
  }, {
    id: 18,
    name: 'Senigallia',
    address: 'Via Marchetti 88'
  }, {
    id: 19,
    name: 'Viareggio',
    address: 'Via Battisti 127'
  }, {
    id: 20,
    name: 'Pesaro (Sede e Spaccio)',
    address: 'Via dei Trasporti 3-5'
  }]);
  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleSave = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      showToast('Profilo aggiornato', 'success');
    }, 1000);
  };
  const handleLogoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({
          ...prev,
          logo: reader.result as string
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  const handleRemoveLocation = (id: number) => {
    setLocations(prev => prev.filter(loc => loc.id !== id));
  };
  const showToast = (message: string, type: 'success' | 'error') => {
    setToast({
      message,
      type,
      show: true
    });
    setTimeout(() => {
      setToast({
        message: '',
        type: 'success',
        show: false
      });
    }, 3000);
  };
  // Filter locations based on search term
  const filteredLocations = locations.filter(location => location.name.toLowerCase().includes(locationSearchTerm.toLowerCase()) || location.address.toLowerCase().includes(locationSearchTerm.toLowerCase()));
  // Show only first 6 locations when collapsed
  const displayedLocations = isLocationsExpanded ? filteredLocations : filteredLocations.slice(0, 6);
  return <div className="flex h-screen bg-gray-50" data-id="element-3042">
      <div className="w-20 flex-shrink-0" data-id="element-3043">
        <Sidebar data-id="element-3044" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3045">
        <Topbar data-id="element-3046" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-3047">
          <PageHeader title="Profilo Partner" subtitle="Gestisci le informazioni visibili e operative del tuo account." primaryAction={{
          label: 'Salva Modifiche',
          onClick: handleSave,
          icon: <Save className="h-4 w-4 mr-2" data-id="element-3049" />
        }} secondaryAction={{
          label: 'Anteprima Profilo',
          onClick: () => navigate('/profile/preview'),
          icon: <Eye className="h-4 w-4 mr-2" data-id="element-3050" />
        }} data-id="element-3048" />

          <div className="space-y-6" data-id="element-3051">
            {/* Identity Section */}
            <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3052">
              <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-3053">
                Identità
              </h3>

              {/* Logo Upload */}
              <div className="mb-6" data-id="element-3054">
                <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-3055">
                  Logo
                </label>
                <div className="flex items-center space-x-6" data-id="element-3056">
                  <div className="flex-shrink-0" data-id="element-3057">
                    <div className="h-24 w-24 rounded-lg border-2 border-gray-200 overflow-hidden bg-white flex items-center justify-center p-2" data-id="element-3058">
                      {formData.logo ? <img src={formData.logo} alt="Logo La Saponaria" className="h-full w-full object-contain" data-id="element-3059" /> : <Upload className="h-8 w-8 text-gray-400" data-id="element-3060" />}
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-3061">
                    <input type="file" id="logo-upload" accept="image/*" onChange={handleLogoUpload} className="hidden" data-id="element-3062" />
                    <label htmlFor="logo-upload" className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-3063">
                      <Upload className="h-4 w-4 mr-2" data-id="element-3064" />
                      Carica Logo
                    </label>
                    <p className="mt-2 text-xs text-gray-500" data-id="element-3065">
                      PNG, JPG o SVG. Dimensione consigliata: 400x400px
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-3066">
                <Input label="Nome Partner" value={formData.name} onChange={e => handleInputChange('name', e.target.value)} required data-id="element-3067" />
                <Input label="Settore" value={formData.sector} onChange={e => handleInputChange('sector', e.target.value)} required data-id="element-3068" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-3069">
                <Input label="Anno di Fondazione" value={formData.founded} onChange={e => handleInputChange('founded', e.target.value)} data-id="element-3070" />
                <Input label="Sede Principale" value={formData.headquarters} onChange={e => handleInputChange('headquarters', e.target.value)} data-id="element-3071" />
              </div>

              <div className="mb-6" data-id="element-3072">
                <div className="flex items-center justify-between mb-2" data-id="element-3073">
                  <label className="block text-sm font-medium text-gray-700" data-id="element-3074">
                    Sito Web
                  </label>
                  <a href={formData.website} target="_blank" rel="noopener noreferrer" className="text-sm text-greenback hover:text-greenback/80 flex items-center gap-1" data-id="element-3075">
                    Visita <ExternalLink className="h-3 w-3" data-id="element-3076" />
                  </a>
                </div>
                <Input type="url" value={formData.website} onChange={e => handleInputChange('website', e.target.value)} placeholder="https://example.com" data-id="element-3077" />
              </div>

              <div className="mb-6" data-id="element-3078">
                <Textarea label="Descrizione" value={formData.description} onChange={e => handleInputChange('description', e.target.value)} placeholder="Descrivi brevemente la tua attività e i tuoi valori..." rows={4} helperText={`${formData.description.length}/500 caratteri`} data-id="element-3079" />
              </div>

              {/* Certifications */}
              <div data-id="element-3080">
                <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-3081">
                  Certificazioni e Riconoscimenti
                </label>
                <div className="flex flex-wrap gap-2" data-id="element-3082">
                  {formData.certifications.map((cert, index) => <span key={index} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-green-50 text-green-700 rounded-full text-sm font-medium border border-green-200" data-id="element-3083">
                      <Leaf className="h-3.5 w-3.5" data-id="element-3084" />
                      {cert}
                    </span>)}
                </div>
              </div>
            </div>

            {/* Locations Section */}
            <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3085">
              <div className="flex items-center justify-between mb-6" data-id="element-3086">
                <div data-id="element-3087">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-3088">Sedi</h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-3089">
                    {locations.length} negozi in tutta Italia
                  </p>
                </div>
                <Button variant="outline" size="sm" onClick={() => setShowAddLocationModal(true)} leftIcon={<Plus className="h-4 w-4" data-id="element-3091" />} data-id="element-3090">
                  Aggiungi Sede
                </Button>
              </div>

              {/* Search Bar */}
              <div className="mb-4" data-id="element-3092">
                <div className="relative" data-id="element-3093">
                  <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" data-id="element-3094" />
                  <input type="text" placeholder="Cerca sede per nome o indirizzo..." className="w-full rounded-lg border border-gray-300 pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-greenback" value={locationSearchTerm} onChange={e => setLocationSearchTerm(e.target.value)} data-id="element-3095" />
                </div>
              </div>

              {/* Locations Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-3096">
                {displayedLocations.map(location => <div key={location.id} className="flex items-start justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-3097">
                    <div className="flex items-start flex-1" data-id="element-3098">
                      <MapPin className="h-5 w-5 text-greenback mt-0.5 mr-3 flex-shrink-0" data-id="element-3099" />
                      <div data-id="element-3100">
                        <p className="font-medium text-gray-900" data-id="element-3101">
                          {location.name}
                        </p>
                        <p className="text-sm text-gray-500 mt-1" data-id="element-3102">
                          {location.address}
                        </p>
                      </div>
                    </div>
                    <button onClick={() => handleRemoveLocation(location.id)} className="ml-4 p-1 text-gray-400 hover:text-red-600 transition-colors" title="Rimuovi sede" data-id="element-3103">
                      <X className="h-5 w-5" data-id="element-3104" />
                    </button>
                  </div>)}
              </div>

              {/* Expand/Collapse Button */}
              {filteredLocations.length > 6 && <div className="mt-4 text-center" data-id="element-3105">
                  <button onClick={() => setIsLocationsExpanded(!isLocationsExpanded)} className="inline-flex items-center gap-2 px-4 py-2 text-sm text-greenback hover:text-greenback/80 font-medium transition-colors" data-id="element-3106">
                    {isLocationsExpanded ? <>
                        Mostra meno
                        <ChevronUp className="h-4 w-4" data-id="element-3107" />
                      </> : <>
                        Mostra tutte ({filteredLocations.length - 6} in più)
                        <ChevronDown className="h-4 w-4" data-id="element-3108" />
                      </>}
                  </button>
                </div>}

              {/* No results message */}
              {filteredLocations.length === 0 && <div className="text-center py-8 text-gray-500" data-id="element-3109">
                  <p data-id="element-3110">
                    Nessuna sede trovata con &quot;{locationSearchTerm}&quot;
                  </p>
                </div>}
            </div>

            {/* Sustainability Section */}
            <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-lg border border-green-200 p-6" data-id="element-3111">
              <div className="flex items-start gap-3" data-id="element-3112">
                <Leaf className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-3113" />
                <div data-id="element-3114">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-3115">
                    Impegno per la Sostenibilità
                  </h3>
                  <ul className="space-y-2 text-sm text-gray-700" data-id="element-3116">
                    <li className="flex items-start gap-2" data-id="element-3117">
                      <span className="text-green-600 mt-0.5" data-id="element-3118">✓</span>
                      <span data-id="element-3119">
                        Produzione 100% artigianale e italiana con energia
                        rinnovabile
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-3120">
                      <span className="text-green-600 mt-0.5" data-id="element-3121">✓</span>
                      <span data-id="element-3122">
                        Ingredienti biologici certificati e filiere etiche fair
                        trade
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-3123">
                      <span className="text-green-600 mt-0.5" data-id="element-3124">✓</span>
                      <span data-id="element-3125">
                        Packaging plastic-free e opzioni zero-waste (cosmetici
                        solidi, ricariche)
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-3126">
                      <span className="text-green-600 mt-0.5" data-id="element-3127">✓</span>
                      <span data-id="element-3128">
                        Prodotti biodegradabili che non inquinano fiumi, mari e
                        laghi
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Add Location Modal */}
      {showAddLocationModal && <>
          <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={() => setShowAddLocationModal(false)} data-id="element-3129"></div>

          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-3130">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6" data-id="element-3131">
              <div className="flex items-center justify-between mb-4" data-id="element-3132">
                <h3 className="text-lg font-semibold" data-id="element-3133">Aggiungi Sede</h3>
                <button onClick={() => setShowAddLocationModal(false)} className="p-1 hover:bg-gray-100 rounded transition-colors" data-id="element-3134">
                  <X className="h-5 w-5 text-gray-500" data-id="element-3135" />
                </button>
              </div>

              <div className="space-y-4" data-id="element-3136">
                <Input label="Nome Sede" placeholder="Es. Milano Centro" data-id="element-3137" />
                <Input label="Indirizzo" placeholder="Via Roma 1, 20121 Milano" data-id="element-3138" />
              </div>

              <div className="flex justify-end gap-3 mt-6" data-id="element-3139">
                <Button variant="outline" onClick={() => setShowAddLocationModal(false)} data-id="element-3140">
                  Annulla
                </Button>
                <Button variant="primary" onClick={() => {
              const newLocation = {
                id: locations.length + 1,
                name: 'Nuova Sede',
                address: 'Indirizzo da configurare'
              };
              setLocations([...locations, newLocation]);
              setShowAddLocationModal(false);
              showToast('Sede aggiunta', 'success');
            }} data-id="element-3141">
                  Aggiungi
                </Button>
              </div>
            </div>
          </div>
        </>}

      {/* Toast Notification */}
      {toast.show && <div className={`fixed bottom-6 right-6 px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in ${toast.type === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'}`} data-id="element-3142">
          {toast.message}
        </div>}
    </div>;
};
export default Profile;